import { ModelBase } from 'store/model-base';
import { DeviceBrand, DeviceType } from 'core/constants';

export class NowDeviceCollection extends ModelBase {
    public static storeName: string = 'nowDeviceCollection';
    public static idAttribute: string = 'lineId';

    public lineId: string;
    public deviceHeader: DeviceHeader;
    public deviceInfo: DeviceInfo;
    public deviceManagement: DeviceManagement;
    public upgrades: DeviceUpgrade;
    public isApple: boolean;
    public isGalaxy: boolean;
    public isPixel: boolean;
    public isMotorola: boolean;
    public is5GCapable: boolean;
    public isTablet: boolean;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowDeviceCollection = super.create<NowDeviceCollection>(initData);
        toReturn.lineId = toReturn.deviceInfo.lineId;
        toReturn.is5GCapable = true; //TODO: Add 5G capability check
        toReturn.isApple = toReturn.deviceInfo?.deviceMake.toLowerCase() === DeviceBrand.APPLE;
        toReturn.isGalaxy = toReturn.deviceInfo?.deviceMake.toLowerCase() === DeviceBrand.SAMSUNG;
        toReturn.isPixel = toReturn.deviceInfo?.deviceMake.toLowerCase() === DeviceBrand.GOOGLE;
        toReturn.isMotorola = toReturn.deviceInfo?.deviceMake.toLowerCase() === DeviceBrand.MOTOROLA;
        toReturn.isTablet = toReturn.deviceInfo?.deviceType.toUpperCase() === DeviceType.TABLET;
        
        return super.create<T>(toReturn);
    }
}
